import React from "react";
import TextInfo from "@gerenciatd/next.components.text-info-n";
import Button from "@gerenciatd/next.components.button-n";

const ShortClickToAction = (props) => {
  const { backGroundColor } = props;
  const backGroundColorCss = `backgroundColor--${backGroundColor}`;
  const mainTaggingInfo = {
    ...props.taggingInfo,
    componentName: 'configuradormimovistar',
  };

  const { custoObjectInfo } = props;
  let textInfoCustoObjectInfo1 = null;
  let textInfoCustoObjectInfo2 = null;
  let textInfoCustoObjectInfo3 = null;

  if (custoObjectInfo) {
    textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: "TextInfo-1",
    });
    textInfoCustoObjectInfo2 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: "TextInfo-2",
    });
    textInfoCustoObjectInfo3 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: "TextInfo-3",
    });
  }
  return (
    <>
      <div className={`shortClickToAction ${backGroundColorCss}`}>
      
          {props["TextInfo-1"] && (
            <div className="lineinfo-gap">
              <TextInfo
                {...props["TextInfo-1"]}
                custoObjectInfo={textInfoCustoObjectInfo1}
              />
            </div>
          )}
          {props["TextInfo-2"] && (
            <div className="lineinfo-gap">
              <TextInfo
                {...props["TextInfo-2"]}
                custoObjectInfo={textInfoCustoObjectInfo2}
              />
            </div>
          )}
          {props["TextInfo-3"] && (
            <div className="lineinfo-gap">
              <TextInfo
                {...props["TextInfo-3"]}
                custoObjectInfo={textInfoCustoObjectInfo3}
              />
            </div>
          )}
          {props["Button-1"] && props["Button-1"].label && (
            <div className="cta-gap">
              <Button
                {...props["Button-1"]}
                taggingInfo={{
                  ...mainTaggingInfo,
                  componentContent: props["Button-1"].label,
                }}
              />
            </div>
          )}
        
      </div>
      <style jsx>
        {`
        @media screen and (min-width: 768px) {
          .cta-gap {                  
            max-width: 13rem;
          }
        }
          .shortClickToAction {
            padding-bottom: 1.5rem;
            padding-top: 0.5rem;
            &.backgroundColor {
              &--white {
                background-color: var(--color-gp--white);
              }
              &--blue {
                background-color: var(--color-gp--blue);
              }
            }
            .lineinfo-gap {
              margin-top: 1rem;
            }
            .cta-gap {
              width:100%;            
              margin-left: auto;
              margin-right: auto;
              margin-top: 1.5rem;
            }
          }
        `}
      </style>
    </>
  );
};
export default ShortClickToAction;
